export class ClientError extends Error {
    constructor(msg: string) {
        super(msg);
        this.name = 'ClientError';
    }
}
